var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m375.6 30c-31.199 0-61.199 12-85.199 34.801-46.801 46.801-46.801 123.6 0 170.4l363.6 364.8-364.8 364.8c-46.801 46.801-46.801 123.6 0 170.4 46.801 46.801 123.6 46.801 170.4 0l450-450c22.801-22.801 34.801-52.801 34.801-85.199s-13.199-62.398-34.801-85.199l-448.8-450c-24-22.801-55.199-34.801-85.199-34.801z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6af8f4d0d46390e04a94944cecf3e0f2.svg";
export { ForwardRef as ReactComponent };